/**
 * User form helper utilities.
 * Functions for handling form field values in the user drawer.
 */

/**
 * Gets the effective form value, preferring userForm value over selectedUser value.
 * Used in edit mode to show user's changes while preserving original data.
 *
 * @param {string} formValue - The current form value (may be empty string if untouched)
 * @param {string} selectedValue - The original value from selectedUser
 * @returns {string} The effective value to display
 */
export const getFormValue = (formValue, selectedValue) => {
    // If formValue is explicitly set (even to empty), use it
    // Otherwise fall back to selectedValue
    return formValue !== '' ? formValue : selectedValue;
};

/**
 * Gets the effective select value, converting to option object format.
 * Used for Select components that need {value, label} objects.
 *
 * @param {Object|string} formValue - The current form value
 * @param {string} selectedValue - The original value from selectedUser
 * @param {Array} options - Array of {value, label} option objects
 * @returns {Object|string} The option object or empty string
 */
export const getSelectFormValue = (formValue, selectedValue, options) => {
    if (formValue !== '') {
        return formValue;
    }
    return options.find((opt) => opt.value === selectedValue) || '';
};
